import { Flex, Box, SimpleGrid } from '@chakra-ui/core'
import React, { useCallback, useState } from 'react'
import { BoardHeader } from '../commonUI/BoardHeader'
import { UserCard } from './UserCard'
import { UsersTable } from './UsersTable'
import { NoResults } from 'components/CommonComponents/GroupsTree/NoResults'
import { useUserModals } from './UserModalsManagerContext'
import { IConfigRetailUser, RootState } from 'constants/interfaces'
import { useSelector, useDispatch } from 'react-redux'
import useLocaleText from 'components/useLocaleText'
import { exportUsersToXLSX } from './utils'
import { fetchRetailUsersForExport } from 'redux/actions/admin'
import { AppDispatch } from 'config/redux'

interface Props {
  users: IConfigRetailUser[]
  viewMode: 'grid' | 'table'
  onChangeViewMode: () => void
  searchQuery: string
  onSearch: (value: string) => void
}

export const UsersBoardContent: React.FC<Props> = ({ users, viewMode, onChangeViewMode, searchQuery, onSearch }) => {
  const { openUserModal } = useUserModals()
  const dispatch: AppDispatch = useDispatch()
  const theme = useSelector((state: RootState) => state.general.theme)
  const { groups, tags } = useSelector((state: RootState) => state.config.config)
  const admin_create_user = useLocaleText('admin_create_user')
  const admin_number_of_users = useLocaleText('admin_number_of_users')
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = useCallback(async () => {
    setIsExporting(true)
    try {
      const enrichedUsers = await dispatch(fetchRetailUsersForExport())
      await exportUsersToXLSX(enrichedUsers, groups, tags)
    } finally {
      setIsExporting(false)
    }
  }, [dispatch, groups, tags])

  return (
    <Flex direction="column">
      <BoardHeader
        title={admin_number_of_users}
        count={users.length}
        createButtonText={admin_create_user}
        onSearch={onSearch}
        onCreate={() => openUserModal()}
        onExport={handleExport}
        isExportLoading={isExporting}
        viewMode={viewMode}
        onViewModeChange={onChangeViewMode}
        theme={theme}
        searchValue={searchQuery}
      />

      <Box position="relative" zIndex={1}>
        {users.length > 0 ? (
          viewMode === 'grid' ? (
            <SimpleGrid columns={{ base: 1, sm: 2, md: 2, lg: 3 }} spacing={4}>
              {users.map((user) => (
                <UserCard key={user.uid} user={user} />
              ))}
            </SimpleGrid>
          ) : (
            <UsersTable users={users} />
          )
        ) : (
          <NoResults />
        )}
      </Box>
    </Flex>
  )
}
